import { cached, tracked } from '@glimmer/tracking';
import { getOwner } from '@ember/application';
import { type Registry as Services } from '@ember/service';
import BookingModel from 'uplisting-frontend/models/booking';
import UnavailabilityModel from 'uplisting-frontend/models/unavailability';
import type { PropertyRowDataItem } from 'uplisting-frontend/services/calendar/data';

export interface IOccasionDto {
  title: string;
  description: string;
  status: string;
}

export class OccasionDto implements IOccasionDto {
  intl!: Services['intl'];

  @cached @tracked _model!: PropertyRowDataItem;

  constructor(context, model: PropertyRowDataItem) {
    this.intl = getOwner(context)?.lookup('service:intl') as Services['intl'];

    this._model = model;
  }

  @cached
  get title(): string {
    const model = this._model;

    if (model instanceof BookingModel) {
      return model.guestName;
    } else if (model instanceof UnavailabilityModel) {
      return model.description;
    }

    return '';
  }

  @cached
  get description(): string {
    const model = this._model;

    if (model instanceof BookingModel) {
      return model.channel;
    } else if (model instanceof UnavailabilityModel) {
      return this.intl.t('calendar.cells.unavailabilities.unavailable');
    }

    return '';
  }

  @cached
  get status(): string {
    const model = this._model;

    if (model instanceof UnavailabilityModel) {
      return model.source || 'unavailable';
    }

    return model.status;
  }
}
